import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetEmployeeI9DocumentsRequest,
  TGetEmployeeI9DocumentsResponse,
} from "./getEmployeeI9DocumentsSchema";

export const getEmployeeI9Documents = (axios: IAxiosInstance) => {
  return async (params: TGetEmployeeI9DocumentsRequest) => {
    const response = await axios.noRetry.get<TGetEmployeeI9DocumentsResponse>(
      `/api/employees/${params.employeeID}/i9-documents`
    );
    return response.data;
  };
};
